import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import PopUpModal from "../PopUpModal/PopUpModal";
import styles from "./ChooseSceneModal.module.css";
import RoomSceneList from "../RoomSceneList/RoomSceneList";
import { ChamUploadButton } from '../../features/ChamUpload/ChamUpload';
import { SERIES_IDS } from '../../../constants';

export default function ChooseSceneModal({ isOpen, onClose, onSceneSelect }) {
    const [activeFilter, setActiveFilter] = useState('All');
    const [categories, setCategories] = useState(['All']);
    const [roomScenes, setRoomScenes] = useState([]);

    // Fetch room scenes and extract categories
    useEffect(() => {
        if (isOpen) {
            const URL = `https://lizard.chameleonpower.com/CDN/RoomScenes/${SERIES_IDS.ROOM_SCENES}.json`;
            fetch(URL)
                .then((response) => response.json())
                .then((data) => {
                    setRoomScenes(data);
                    
                    // Extract unique categories from description field (use exact values)
                    const categorySet = new Set(['All']);
                    data.forEach(scene => {
                        if (scene.description) {
                            categorySet.add(scene.description.trim());
                        }
                    });
                    
                    setCategories(Array.from(categorySet));
                });
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const handleSceneSelect = (specifier) => {
        if (onSceneSelect) {
            onSceneSelect(specifier);
        }
        onClose();
    };

    const handleFilterClick = (category) => {
        setActiveFilter(category);
    };

    return (
        <PopUpModal handleClose={onClose} title="">
            <div className={styles.modalContent}>
                <h2 className={styles.modalTitle}>Choose a Scene</h2>
                <div className={styles.filterContainer}>
                    {categories.map(category => (
                        <button
                            key={category}
                            className={`${styles.filterButton} ${activeFilter === category ? styles.active : ''}`}
                            onClick={() => handleFilterClick(category)}
                        >
                            {category}
                        </button>
                        
                    ))}

                </div>

                <RoomSceneList
                    seriesId={SERIES_IDS.ROOM_SCENES}
                    thumbnailSize="600"
                    onSceneSelect={handleSceneSelect}
                    filterCategory={activeFilter}
                    roomScenes={roomScenes}
                />

                                <div className={styles.uploadContainer}>
                    <ChamUploadButton title="Upload Room Scene" className={styles.uploadButton} />
                </div>
            </div>
        </PopUpModal>
    );
}

ChooseSceneModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSceneSelect: PropTypes.func,
};